import { useHotkeys } from 'react-hotkeys-hook';
import { FC } from 'react';
import { isMacOs } from 'react-device-detect';

interface BPKeyboardShortcutProps {
  shortcutKey: string;
  modifier?: 'ctrl' | 'alt' | 'shift';
  callback: (event: KeyboardEvent) => void;
  enabled?: boolean;
  render?: boolean;
}

const displayText: { [key: string]: string } = {
  ctrl: 'Ctrl',
  alt: 'Alt',
  shift: 'Shift',
  meta: '⌘',
  escape: 'esc',
  enter: 'enter',
};

const BPKeyboardShortcut: FC<BPKeyboardShortcutProps> = ({
  shortcutKey,
  modifier = null,
  callback,
  enabled = true,
  render = true,
}) => {
  const deviceModifier: string = modifier
    ? modifier === 'ctrl'
      ? isMacOs
        ? 'meta'
        : modifier
      : modifier
    : '';
  const modifierDisplay: string = displayText[deviceModifier];

  useHotkeys(
    `${deviceModifier ? deviceModifier + '+' : ''}${shortcutKey}`,
    callback,
    { enabled: enabled }
  );

  const display = modifier
    ? `${modifierDisplay} + ${shortcutKey.toUpperCase()}`
    : displayText[shortcutKey.toLowerCase()] ?? shortcutKey;

  return (
    <>
      {enabled && render ? (
        <div className="inline-block relative p-[3px_6px] rounded-[4px] overflow-hidden bg-white/10 border border-white/10 text-[10px] leading-normal">
          {display}
        </div>
      ) : (
        <div />
      )}
    </>
  );
};

export default BPKeyboardShortcut;
